import { Icon } from '@chakra-ui/react';

export const CircleGlobeIcon = () => (
  <Icon viewBox="0 0 64 64" boxSize={4}>
    {/* Circle background */}
    <circle
      cx="32"
      cy="32"
      r="31"
      fill="white"
      style={{ fill: 'white' }}
      opacity="0.8"
    />

    {/* Globe icon */}
    <g
      transform="translate(13.2, 13.2) scale(0.96)"
      fill="none"
      stroke="#243656"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {/* Outer circle of globe */}
      <circle cx="20" cy="20" r="18" />

      {/* Horizontal line */}
      <path d="M2,20 L38,20" />

      {/* Vertical arc */}
      <path d="M20,2 C29,8 29,32 20,38 C11,32 11,8 20,2" />
    </g>
  </Icon>
);
